// extracted by mini-css-extract-plugin
export default {"licenseHeader":"licenseHeader---Ev31T"};